import React from 'react';
import PropTypes from 'prop-types';
import Container from './Container';
import Image from './Image';

const Avatar = ({ src, width, height, children, ...props }) => (
  <Container
    width={width || height || '100px'}
    height={height || width || '100px'}
    borderRadius="100%"
    overflow="hidden"
    backgroundColor="background300"
    {...props}
  >
    <Container height="100%" width="100%">
      {children || (
        <Image
          objectFit="cover"
          src={src}
          alt="Avatar"
          width="100%"
          height="100%"
        />
      )}
    </Container>
  </Container>
);

Avatar.propTypes = {
  src: PropTypes.string,
  children: PropTypes.node,
  width: PropTypes.string,
  height: PropTypes.string,
};

Avatar.defaultProps = {
  src: '',
  children: null,
  width: null,
  height: null,
};

export default Avatar;
